import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Compliance Desk.
 * Contains menu items for compliance and infraction management.
 */
export const complianceMenu: IMenuItem = {
  label: `Compliance Desk`,
  path: `compliance-desk`,
  id: 'MID_COMPLIANCE_DESK',
  icon: 'fa fa-shield-halved',
  children: [
    { path: `infraction-list`, label: `Infraction List`, id: 'MID_COMPLIANCE_INFRACTIONS' },
    { path: `company/view`, label: `Company`, id: 'MID_COMPLIANCE_COMPANY' },
    { path: `supervisory-returns`, label: `Supervisory Returns`, id: 'MID_COMPLIANCE_RETURNS' },
    { path: `products`, label: `Products`, id: 'MID_COMPLIANCE_PRODUCTS' },
    // { path: `third-party-fraud`, label: `Third Party Fraud`, id: 'MID_COMPLIANCE_THIRD_PARTY_FRAUD' },
  ],
};
